/* eslint-disable no-shadow */
import { call, takeLatest } from "redux-saga/effects";
import noop from "lodash.noop";

import {
    LOAD_REQUESTED, //LOAD_SUCCESS LOAD_FAIL,
    failLoadCombinedContextLoader,
    successLoadCombinedContextLoader,
    progressLoadCombinedContextLoader,
    LOAD_INSTANCE_REQUESTED,
    successLoadWorkflowInstance,
    failLoadWorkflowInstance

} from "./combinedContextLoader.duck";

import { loadCurrentContext, loadCurrentWorkflowInstanceContext } from "./combinedContextLoader.api";

import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";

import {
    getId,
    injectApiWithContextFactory,
    injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        failLoadCombinedContextLoader,
        successLoadCombinedContextLoader,
        progressLoadCombinedContextLoader,
        successLoadWorkflowInstance,
        failLoadWorkflowInstance
    },
    getId
);

export const withApiContext = injectApiWithContextFactory(
    {
        loadCurrentContext,
        loadCurrentWorkflowInstanceContext
    },
    injectBoundGQLClient
);

export function* loadCurrentOrganisationSaga({
    actions: { failLoadCombinedContextLoader, successLoadCombinedContextLoader, progressLoadCombinedContextLoader },
    api: { loadCurrentContext, loadCurrentWorkflowInstanceContext },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield loadCurrentContext();
        const { projectEdges = []} = result;

        let currentproject = "1";
        try {
            // use mdv2 getCookie method if available, otherwise try and read from url hash
            if (window?.app?.Duchess?.getCookie){
                currentproject = window.app.Duchess.getCookie("CurrentProjectID");
            } else {
                const {
                    context: { CurrentProjectID },
                } = Object.fromEntries(
                    window.location.hash
                        .substring(1)
                        .split("&")
                        .map(i => i.split("="))
                        .map(([ key, val ]) => val.includes("/")
                            ? [
                                key,
                                Object.fromEntries(
                                    val.split(",").map(j => j.split("/"))
                                ),
                            ]
                            : [ key, val ]));
                currentproject = CurrentProjectID;
            }
        } catch (e){
            console.error(e);
        }

        const { node: { _id } } = projectEdges.find(({ node: { legacyId } }) => legacyId === currentproject) || {};
        yield progressLoadCombinedContextLoader({ ...result, project: _id });

        const currentDoc = window?.app?.Duchess?.getCookie?.("CurrentDocumentID");
        const { _id: workflowinstance } = currentDoc ? (yield loadCurrentWorkflowInstanceContext({ docId: `${_id}-${currentDoc}` })) || {} : {};
        
        yield successLoadCombinedContextLoader({ ...result, project: _id, workflowinstance });
        yield call(resolve);
    } catch (e) {
        console.error(e);
        yield failLoadCombinedContextLoader(e);
        yield call(reject, e);
    }
}

export function* loadCurrentWorkflowInstanceSaga({
    data,
    api: { loadCurrentWorkflowInstanceContext = noop },
    actions: {
        successLoadWorkflowInstance = noop,
        failLoadWorkflowInstance = noop,
    },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield loadCurrentWorkflowInstanceContext({ docId: data });
        yield successLoadWorkflowInstance({ workflowinstance: result?._id });
        yield call(resolve);
    } catch (e) {
        console.error(e);
        yield failLoadWorkflowInstance(e);
        yield call(reject, e);
    }
}

export default () =>
    function* rootSaga() {
        yield takeLatest(
            LOAD_REQUESTED,
            withBoundActions(withApiContext(loadCurrentOrganisationSaga))
        );
        yield takeLatest(
            LOAD_INSTANCE_REQUESTED,
            withBoundActions(withApiContext(loadCurrentWorkflowInstanceSaga))
        );
    };
